export const films = [
  {
    id: 1,
    title: "Forest Gump",
    director: "Robert Zemeckis",
    image: "https://cdn.cinematerial.com/p/297x/hncfztv7/forrest-gump-movie-poster-md.jpg?v=1602182137",
    description:
      "Forrest Gump adalah seorang pria dengan IQ di bawah rata-rata yang secara tak terduga terlibat dalam berbagai peristiwa sejarah Amerika Serikat dari tahun 1950-an hingga 1970-an, seperti Perang Vietnam, pertemuan dengan presiden, dan pendirian perusahaan teknologi ternama. Meskipun memiliki keterbatasan fisik dan intelektual, ia hidup dengan ketulusan, optimisme, dan mengikuti alur hidup tanpa rencana, yang membuatnya menginspirasi orang-orang di sekitarnya. ",
    review: 
    `
    Film ini masterpiece yang tak bisa di elak an oleh banyak orang, dari film ini saya belajar tentang sebuah penerimaan dan keterikatan batin manusia terhadap ke pasrahan yang positif. Seperti tokoh utama di film ini yang kita disepanjang cerita dari kecil hingga akhir film memiliki karakteristik jalanin aja yang ada dikehidupan.
    Ini merupakan sebuah umpama ajaran Taonisme, dimana kehidupan akan selalu berjalan seperti sungai mengalir dan kita bisa mengikuti arus itu hingga ke ujung kehidupan itu tanpa melawan arus dan nikmati yang ada.
    Selain itu di film ini terasa hidup karena banyak sekali aspek yang dibawa di film ini dan banyak simbolis yang ada di film ini. Seperti Yin dan Yang, diantara tokoh utama dengan first lovenya atau Taonisme yang kita bahas tadi. 
    Terlebih lagi aksi akting Tom Hanks yang membawa perannya sangat mendalam dan sangat menyentuh hati penonton.
    Karena hal itu membuat film ini sangat hidup dan membuat saya menikmati disepanjang filmnya, sebuah eksperience menonton yang indah dan bermakna.
    `,
    genre: "Drama, Comedy, Romance",
    category: "S",
    type: "movie",
    duration: "142 min",
    releaseYear: 1994,
    rating: 8.2,
    personalRating: 5,
  },
  {
    id: 2,
    title: "A Beautiful Mind",
    director: "Ron Howard",
    image: "https://cdn.cinematerial.com/p/297x/nqkzs4iz/a-beautiful-mind-movie-poster-md.jpg?v=1456389079",
    description:
      "Film ini adalah kisah nyata tentang John Nash, seorang matematikawan jenius yang didiagnosis menderita skizofrenia dan mengalami halusinasi serta delusi. ",
    review: 
    `
    Film biografi yang sangat menakjubkan dengan pesan moral yang tersirat di akhir plot cerita, sebuah plot twist dan cerita yang membawa kita memprediksi mana yang benar atau yang tidak.
    Sebelumnya saya menonton film ini tanpa mengetahui apa pun yang ada didalam film ini, untungnya begitu hingga saat diakhir saya mengetahui bahwa film ini berdasarkan dari kisah nyata saya sangat takjub akan hal itu.
    `,
    genre: "Drama",
    category: "S",
    type: "movie",
    duration: "135 min",
    releaseYear: 2001,
    rating: 8.2,
    personalRating: 4.5,
  },
  {
    id: 3,
    title: "The Pianist",
    director: "Roman Polanski",
    image: "https://cdn.cinematerial.com/p/297x/rwodwsr1/the-pianist-movie-poster-md.jpg?v=1456159412",
    description:
      "Film ini mengisahkan upaya Szpilman melarikan diri dari Ghetto Warsawa dan bertahan hidup di antara reruntuhan kota, menunjukkan kekejaman Nazi, tetapi juga momen-momen kemanusiaan melalui bantuan tentara Jerman yang peduli musik. ",
    review: 
    `
    Film yang luar biasa hingga saya tidak menyangka bahwa film ini berdasarkan dari kisah nyata, sebuah perjuangan antara bertahan hidup ditengah konflik kekuasaan dengan kebebasan untuk menyentuh musik.
    Film ini dibalut dengan epik dan penuh emosional disepanjang filmnya, saya sangat bersimpati terhadap tokoh utama difilm ini dari awal hingga ke akhir film.
    Kekejaman, penderitaan dan emosi selalu ada difilm ini dan akting disetiap karakternya sangat menjiwai dan membawa emosional ketika menontonnya
    Ini bukan film aksi yang dimana tokoh utamanya bisa melawan, tetapi dalam kenyataannya tokoh utama merupakan kekejaman perang antara penguasa dengan kemanusiaan.
    Saya sangat menyukai pembawaan musik classic yang dimainkan di film ini dan semua musik itu menjadi playlist favorit saya.
    `,
    genre: "Drama, Music, War",
    category: "S",
    type: "movie",
    duration: "138 min",
    releaseYear: 2003,
    rating: 8.2,
    personalRating: 5.0,
  },
  {
    id: 4,
    title: "Schindler's List ",
    director: "Steven Spielberg",
    image: "https://cdn.cinematerial.com/p/297x/qbsdx7kq/schindlers-list-movie-poster-md.jpg?v=1456259195",
    description:
      "Film ini mengisahkan Oskar Schindler (diperankan oleh Liam Neeson), seorang oportunis yang kemudian menjadi penyelamat tak ternilai, menggunakan pabriknya di Kraków untuk memberikan perlindungan bagi ribuan Yahudi-Polandia dari ancaman kamp konsentrasi Nazi. ",
    review: 
    `
    Schindler's List, adalah film tentang kemanusiaan disaat perang, sebuah film yang selalu menyentuh hati ketika mendengar soundtrancknya.
    Ketika saya menonton film ini, saya benar-benar takjub akan pengorbanan dan dedikasi untuk menyelamatkan semua orang di kekejaman pemerintahan Nazi.
    Ini memang film yang berdasarkan dari kisah nyata, saya sangat takjub terhadap tokoh Oskar Schindler yang membawa dedikasi kemanusiaan luar biasa pada perang dunia ke-2. Ditengah-tengah kekejaman dan penderitaan dunia disaat itu, ternyata masih ada orang-orang baik, masih ada harapan di tengah kegelapan yang mewarnai hidup orang-orang masa itu.
    Akting yang luar biasa dari Liam Nelson juga turut diapresiasi, dimana beliau membawa tokoh Oskar Schindler dengan penuh emosional dan pertimbangan moral yang terus ia bawa hingga akhir film.
    Film ini merupakan simbol tragedik perang dunia ke 2, dan saya harap selalu ada orang baik didunia ini seperti Oskar Schindler.

    `,
    genre: "Drama, War",
    category: "S",
    type: "movie",
    duration: "195 min",
    releaseYear: 1993,
    rating: 9.0,
    personalRating: 5.0,
  },
  {
    id: 5,
    title: "The Batman",
    director: "Matt Reeves",
    image: "https://cdn.cinematerial.com/p/297x/fhfecufs/the-batman-movie-poster-md.jpg?v=1645104442",
    description:
      "Ketika Riddler, seorang pembunuh berantai yang sadis mulai membunuh tokoh-tokoh politik penting di Gotham, Batman dituntut untuk menyelidiki korupsi tersembunyi di kota itu dan mempertanyakan keterlibatan keluarganya.",
    review: 
    `
    Matt Reeves membawa angin segar terhadap dunia superhero, tentang moral dan dunia kegelapan yang dialami di masyarakat.
    Batman difilm ini menjadi simbol ketakutan terhadap para kriminal tetapi juga ia merupakan simbol perlawanan atas kekejaman dunia ini.
    Film ini sangat dibalut dengan aksi detektif-detektif an Batman yang jarang diadaptasi di film-film sebelumnya, ini merupakan angin segar dikala itu film-film superhero yang mementingkan aksi blockbuster saja
    Saya sangat menyukai karakter Batman dan ini merupakan film Batman terbaik saya saya nonton sejauh ini.
    `,
    genre: "Action, Superhero, Thriller, Crime",
    category: "S",
    type: "movie",
    duration: " 176 min",
    releaseYear: 2022,
    rating: 7.8,
    personalRating: 5.0,
  },
  {
    id: 6,
    title: "Oppenheimer",
    director: "Christopher Nolan",
    image: "https://cdn.cinematerial.com/p/297x/vhigu8yx/oppenheimer-movie-poster-md.jpg?v=1690172793",
    description:
      "Film Oppenheimer menceritakan kisah fisikawan Amerika J. Robert Oppenheimer, yang memimpin pengembangan bom atom pertama di dunia melalui Proyek Manhattan selama Perang Dunia II, serta mengeksplorasi konflik etika dan konsekuensi dari penemuannya tersebut",
    review: 
    `
    Oppenheimer menjadi film biografi yang sangat memuaskan secara visual dan kekompleks-an moral sebuah tokoh terkenal dan konterversial yaitu Oppenheimer.
    Christoper Nolan memang maestronya membuat praktikal efek yang terlihat seperti nyata dan sfxnya yang sangat memorible. Selain itu juga scoring musik nya yang sangat fantastis.

    Antara moral dan pekerjaan, Oppenheimer yang masih memiliki hati nurani pada akhirnya ia memiliki penyesalan tanpa akhir tentang proyek yang ia kerjakan yaitu membuat bom atom yang pada akhirnya membawa korban ribuan orang di Jepang.
    Film ini dikemas dengan sangat baik, dari segi pembawaan cerita dan juga visual yang memanjakan mata.
    `,
    genre: "Adventure, Drama, Sci-Fi",
    category: "S",
    type: "movie",
    duration: "180 min",
    releaseYear: 2023,
    rating: 8.3,
    personalRating: 5.0,
  },
  {
    id: 7,
    title: "Interstellar",
    director: "Christoper Nolan",
    image: "https://cdn.cinematerial.com/p/297x/ctpnz4mq/interstellar-movie-poster-md.jpg?v=1456424450",
    description:
      "Sebuah tim penjelajah antar galaksi harus melewati lubang cacing dan terjebak di dimensi waktu ruang angkasa dalam upaya untuk menjamin kelangsungan hidup umat manusia di planet bumi.",
    review: `Bagi saya film Interstellar menjadi film Sci-fi terbaik selama dekade terakhir. Karena disetiap perjalanan mengaruhi luasnya alam semesta dibalut dengan epik dan narasinya yang membuat kita selalu membahasnya di setiap ada pembahasaan film terbaik sepanjang masa.
    Interstellar membawa kita kepada "What IF" manusia pada akhirnya ada di ujung perjalanan spesiesnya. Bumi bisa dibilang sekarat dan manusia tidak mempunyai tujuan lain selain mencari tempat tinggal lain.
    Narasi yang dibalut dengan rapih dan ending yang cukup memuaskan`,
    genre: "Drama, Sci-Fi",
    category: "A",
    type: "movie",
    duration: "159 min",
    releaseYear: 2014,
    rating: 8.7,
    personalRating: 4.5,
  },
  {
    id: 8,
    title: "Joker",
    director: "Todd Phillips",
    image: "https://m.media-amazon.com/images/M/MV5BNGVjNWI4ZGUtNzE0MS00YTJmLWE0ZDctN2ZiYTk2YmI3NTYyXkEyXkFqcGdeQXVyMTkxNjUyNQ@@._V1_FMjpg_UX1000_.jpg",
    description:
      "In Gotham City, mentally troubled comedian Arthur Fleck is disregarded and mistreated by society. He then embarks on a downward spiral of revolution and bloody crime. This path brings him face-to-face with his alter-ego: the Joker. A gritty character study of Arthur Fleck, a man disregarded by society.",
    review: `Joker adalah character study yang disturbing dan powerful tentang seseorang yang terpinggirkan oleh masyarakat. Joaquin Phoenix memberikan tour de force performance yang physically dan emotionally transformative. Penurunan mental Arthur Fleck digambarkan dengan raw intensity yang kadang uncomfortable untuk ditonton.

    Film ini berdiri sendiri sebagai drama sosial yang berbicara tentang mental health, inequality, dan bagaimana masyarakat menciptakan monster yang mereka takuti. Meski terinspirasi dari komik Batman, film ini lebih dekat ke Taxi Driver dan The King of Comedy daripada film superhero biasa.

    Ending yang ambiguous meninggalkan penonton dengan pertanyaan tentang realitas versus delusi. Joker membuktikan bahwa film komik bisa menjadi medium untuk eksplorasi karakter yang dark dan complex.`,
    genre: "Crime, Drama, Thriller",
    category: "A",
    type: "movie",
    duration: "122 min",
    releaseYear: 2019,
    rating: 8.4,
    personalRating: 4.5,
  },
  {
    id: 9,
    title: "Peacemaker",
    director: "James Gunn",
    image: "https://cdn.cinematerial.com/p/297x/hc3ecbpd/peacemaker-movie-poster-md.jpg?v=1753466541",
    description:
      "Peacemaker is a superhero series focusing on the character from The Suicide Squad. After recovering from his injuries, Christopher Smith / Peacemaker is forced to work with a secret government agency on a mission named 'Project Butterfly'.",
    review: `Peacemaker adalah series yang surprisingly heartfelt dan hilarious. John Cena benar-benar menemukan peran yang sempurna untuk bakat komedinya. Karakter Peacemaker yang semula tampak sebagai parodi justru berkembang menjadi karakter yang complex dan surprisingly sympathetic.

    Chemistry antara seluruh cast, terutama dengan John Economos dan Clemson Murn, menciptakan dynamic group yang entertaining. Setiap episode dipadati dengan humor yang sharp, aksi yang brutal, dan momen-momen emotional yang tiba-tiba muncul.

    Opening credit sequence dengan dance number yang awkwardly brilliant sudah menjadi ikon tersendiri. Series ini membuktikan bahwa James Gunn memahami bagaimana membuat karakter komik yang flawed namun tetap relatable.`,
    genre: "Action, Comedy, Drama",
    category: "A",
    type: "series",
    duration: "8 Episodes",
    releaseYear: 2022,
    rating: 8.4,
    personalRating: 4.5,
  },
  {
    id: 10,
    title: "The Penguin",
    director: "Craig Zobel",
    image: "https://cdn.cinematerial.com/p/297x/x2qqzmpy/the-penguin-movie-poster-md.jpg?v=1730134879",
    description:
      "The Penguin series follows the rise of Oswald Cobblepot in the criminal underworld of Gotham City. Set after the events of The Batman, the series explores how the Penguin builds his empire and becomes one of Gotham's most feared crime lords.",
    review: `The Penguin adalah crime drama yang atmospheric dan compelling. Colin Farrell menghidupkan kembali karakternya dengan transformation yang remarkable. Series ini feels like a proper crime saga yang kebetulan berada di dunia Batman.

    Gotham City digambarkan dengan gritty realism yang konsisten dengan film The Batman. Pengembangan karakter Oswald Cobblepot dari henchman menjadi kingpin executed dengan pacing yang tepat. Setiap episode membangun tension dan stakes dengan efektif.

    Series ini berhasil memperluas dunia The Batman tanpa merasa seperti filler content. The Penguin stands on its own sebagai crime story yang solid tentang power, ambition, dan consequence.`,
    genre: "Crime, Drama",
    category: "A",
    type: "series",
    duration: "8 Episodes",
    releaseYear: 2024,
    rating: 8.2,
    personalRating: 4.0,
  },
  {
    id: 11,
    title: "Your Name",
    director: "Makoto Shinkai",
    image: "https://cdn.cinematerial.com/p/297x/lwha2oye/kimi-no-na-wa-japanese-movie-poster-md.jpg?v=1630399147",
    description:
      "Two teenagers share a profound, magical connection upon discovering they are swapping bodies. Things manage to become even more complicated when the boy and girl decide to meet in person. Mitsuha and Taki navigate each other's lives, relationships, and a looming disaster.",
    review: `Your Name adalah masterpiece visual dan emotional dari Makoto Shinkai. Film ini menggabungkan elemen fantasi, romance, dan drama dengan seamless execution. Animasi yang breathtaking membuat setiap frame layak dijadikan wallpaper.

    Chemistry antara Taki dan Mitsuha dibangun dengan natural meski mereka tidak pernah bertemu secara langsung. Plot twist di pertengahan film mengubah seluruh perspektif cerita dan meningkatkan emotional stakes secara signifikan.

    Film ini berbicara tentang connection, memory, dan bagaimana orang yang tepat bisa menemukan satu sama lain melintasi waktu dan ruang. Ending yang emotionally satisfying membuat Your Name menjadi salah satu anime terbaik yang pernah dibuat.`,
    genre: "Animation, Drama, Romance",
    category: "S",
    type: "anime",
    duration: "106 min",
    releaseYear: 2016,
    rating: 8.4,
    personalRating: 5.0,
  },
  {
    id: 12,
    title: "Perfect Days",
    director: "Wim Wenders",
    image: "https://cdn.cinematerial.com/p/297x/wglpq5op/perfect-days-international-movie-poster-md.jpg?v=1685224638",
    description:
      "Hirayama feels content with his life as a toilet cleaner in Tokyo. Outside his structured routine, he cherishes music on cassette tapes, reads books and takes photos. Through unexpected encounters, he reflects on finding beauty in the world.",
    review: `Ketika sebuah cerita kebanyakan pakai template ada masalah lalu diakhiri dengan solusi atau apapun itu.
    Film ini jadi pembeda dari banyak cerita apapun di per film-an. Jadi kita dibawa untuk melihat keseharian tukang bersih-bersih toilet di Jepang dan sepanjang film ini nothing spesial kecuali film ini indah dengan sendirinya.

    Mungkin sebagian besar orang akan tidak betah nonton film ini, karena emng slow burn dan kita cuman ngeliat perjalanan orang bersih-bersih toilet aja, ga ada yang spesial dan rasanya kaya film dokumentsi kehidupan sehari-hari aja. Tapi bagi saya dan bagi sebagian orang bakal dapet feel yang sangat dalam.

    Kehidupan sehari-hari di sisipkan makna untuk hal-hal kecil. Film ini ingin menyampaikan betapa indahnya kita punya kontrol sepenuhnya dalam kehidupan kita sendiri, menikmati setiap detik nya hidup ini dan menikmati apa yang dunia berikan pada kita. Hal-hal paling kecil yang mungkin kita lewatkan, mungkin saja sangat berharga untuk kita seumur hidup dan film ini mampu memberi makna itu.
    Dari hal-hal kecil seperti bayangan pepohonan terkena matahari, indahnya langit, sejuknya udara di pagi hari, mendengarkan lagu-lagu dan masih banyak lagi. Yang saya dapat dari film ini adalah tokoh utama bekerja dengan sepenuh sadar akan dirinya sedang bekerja, ia tidak membuat dirinya auto pilot untuk bekerja dan masih menikmati setiap detiknya pekerjaan itu walaupun dia bekerja sebagai tukang bersih toilet serta karena pekerjaan itu dia menjadi sosok yang tidak malu dan malah dia sangat perfectionis dalam pekerjaannya seakan ia seorang seniman dari pekerjaannya ia membersihkan dalam skala sangat detail.`,
    genre: "Psychological Drama, Drama",
    category: "S",
    type: "movie",
    duration: "124 min",
    releaseYear: 2023,
    rating: 7.9,
    personalRating: 5.0,
  },
  {
    id: 13,
    title: "5 Centimeters Per Second",
    director: "Makoto Shinkai",
    image: "https://cdn.cinematerial.com/p/297x/hxmrpmwl/byousoku-5-senchimeetoru-japanese-movie-poster-md.jpg?v=1456325790",
    description:
      "Takaki and Akari are in elementary school and over time become best friends. Their friendship is put to the test when Akari has to move to another city.",
    review: `Kisah ini tidak sempurna tetapi itu adalah nilai dari film ini, seperti puisi bagi saya apa yang terjadi di film ini adalah seseorang yang tidak bisa mengungkapkan isi hatinya kepada orang yang ia cintai, dan karena hal itu ia kehilangan kesempatan untuk bersama dengan orang yang ia cintai.
    Film ini sangat indah secara visual. Animasinya, soundtracknya, dan setiap kata-kata yang diucapkan dari beberapa tokoh sangat menyentuh hati saya.
    Seperti yang saya bilang tadi, film ini seperti puisi yang tak bisa mengungkapkan isi hati dengan kata-kata tetapi sebagai penikmat kita paham apa yang ingin disampaikan. 
    `,
    genre: "Psychological Drama, Drama, Romance, Animation",
    category: "A",
    type: "anime",
    duration: "63 min",
    releaseYear: 2007,
    rating: 7.4,
    personalRating: 4.0,
  },
  {
    id: 14,
    title: "Hyakuemu",
    director: "Kenji Iwaizawa",
    image: "https://cdn.cinematerial.com/p/297x/agfsjcoy/hyakuemu-japanese-movie-poster-md.jpg?v=1757797788",
    description:
      "Togashi, a talented runner, is motivated by transfer student Komiya to train harder. Years later, they face off as rivals on the racetrack.",
    review: `Sebuah karya anime yang sangat indah, dengan visual yang sangat memanjakan mata, dan animasi yang gila. Teknik animasi yang digunakan adalah teknik rotoscoping yang dimana membuat animasi ini menjadi sangat hidup.
    Selain visual dan animasi yang indah, saya sangat menikmati bagaimana penceritaan yang disampaikan dari anime ini. Sebuah perjuangan, ketidakadilan dari dunia, dan kenyataan pahit kehidupan ini. 
    Yang mempunyai bakat dari lahir belum tentu berhasil jika ia tidak menikmati proses yang ada, dan yang tidak punya bakat bawaan mungkin berhasil jika ia bekerja keras. Tamparan pahit dari awal hingga menjelang akhir, bahwa MC yang punya bakat bawaan bisa kalah dengan orang yang bekerja keras. Namun diakhir, anime ini menyugguhkan solusi sederhana, yaitu menikmati proses yang ada, di setiap detik dan setiap balutan nafas yang dikeluarkan dari jiwa kita adalah bukti bahwa kita menang dalam kehidupan kita.
    Saya mungkin mengubah pandangan saya tentang dunia, tentang kehidupan, dan tentang bagaimana kita mengejar sesuatu dari anime ini. Sebuah mahakarya yang memberi makna kepada penontonnya adalah sebuah karya yang sangat indah seperti anime ini.
    `,
    genre: "Psychological Drama, Sports, Animation",
    category: "S",
    type: "anime",
    duration: "106 min",
    releaseYear: 2025,
    rating: 7.6,
    personalRating: 5.0,
  },
];

export const getTierColor = (tier) => {
  switch (tier) {
    case "S":
      return { bg: "bg-purple-100", text: "text-purple-800", border: "border-purple-300" };
    case "A":
      return { bg: "bg-blue-100", text: "text-blue-800", border: "border-blue-300" };
    case "B":
      return { bg: "bg-green-100", text: "text-green-800", border: "border-green-300" };
    case "C":
      return { bg: "bg-yellow-100", text: "text-yellow-800", border: "border-yellow-300" };
    default:
      return { bg: "bg-gray-100", text: "text-gray-800", border: "border-gray-300" };
  }
};

export const getTypeColor = (type) => {
  switch (type) {
    case "movie":
      return { bg: "bg-red-100", text: "text-red-800", border: "border-red-300" };
    case "series":
      return { bg: "bg-orange-100", text: "text-orange-800", border: "border-orange-300" };
    case "anime":
      return { bg: "bg-pink-100", text: "text-pink-800", border: "border-pink-300" };
    default:
      return { bg: "bg-gray-100", text: "text-gray-800", border: "border-gray-300" };
  }
};

export const renderStars = (rating) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;

  for (let i = 0; i < fullStars; i++) {
    stars.push(<span key={i}>★</span>);
  }

  if (hasHalfStar) {
    stars.push(<span key="half">½</span>);
  }

  const emptyStars = 5 - stars.length;
  for (let i = 0; i < emptyStars; i++) {
    stars.push(<span key={`empty-${i}`}>☆</span>);
  }

  return stars;
};